import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const UserForm = ({ initialData = {}, onSubmit, isEditMode = false, onLogout }) => {
  const [username, setUsername] = useState(initialData.username || '');
  const [password, setPassword] = useState(''); // Initialize password as empty
  const [email, setEmail] = useState(initialData.email || '');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showPassword, setShowPassword] = useState(false); // State to toggle password visibility
  const navigate = useNavigate();

  useEffect(() => {
    if (initialData.username) setUsername(initialData.username);
    if (initialData.email) setEmail(initialData.email);
    if (isEditMode) setPassword('********'); // Pre-fill password with placeholder for existing users
  }, [initialData, isEditMode]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!username || !password || !email) {
      setError('Nom, mot de passe et email obligatoires');
      return;
    }

    const userData = { username, password, email };

    try {
      await onSubmit(userData);
      setSuccess(isEditMode ? 'Compte mis à jour avec succès !' : 'Compte créé avec succès !');
      setError('');
      if (!isEditMode) {
        setUsername('');
        setPassword('');
        setEmail('');
        navigate('/'); // Redirect to the home page after account creation
      }
    } catch (err) {
      console.error('Error submitting form:', err);
      setError('Erreur lors de la soumission du formulaire');
    }
  };

  return (
    <div style={styles.page}>
      <h1 style={styles.title}>{isEditMode ? 'Mon compte' : 'Créer un compte'}</h1>
      {error && <p style={styles.error}>{error}</p>}
      {success && <p style={styles.success}>{success}</p>}
      <form onSubmit={handleSubmit} style={styles.form}>
        <div style={styles.formGroup}>
          <label htmlFor="username" style={styles.label}>Pseudonyme</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="email" style={styles.label}>Adresse mail</label>
          <input
            type="email"
            id="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="password" style={styles.label}>Mot de passe</label>
          <div style={styles.passwordContainer}>
            <input
              type={showPassword ? 'text' : 'password'} // Toggle between text and password
              id="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={styles.input}
            />
            <button
              type="button"
              onClick={() => setShowPassword((prev) => !prev)} // Toggle visibility
              style={styles.toggleButton}
            >
              {showPassword ? 'Cacher' : 'Afficher'}
            </button>
          </div>
        </div>

        <div style={styles.buttonGroup}>
          <button type="submit" style={styles.button}>
            {isEditMode ? 'Mettre à jour' : 'Créer mon compte'}
          </button>
          {isEditMode && (
            <button type="button" onClick={onLogout} style={styles.logoutButton}>
              Déconnexion
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

const styles = {
  page: { textAlign: 'center', padding: '20px' },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' },
  form: { maxWidth: '400px', margin: '0 auto', textAlign: 'left' },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: { width: '100%', padding: '10px', fontSize: '16px', borderRadius: '5px', border: '1px solid #ccc' },
  passwordContainer: {
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
  },
  toggleButton: {
    position: 'absolute',
    right: '10px',
    padding: '5px 10px',
    fontSize: '12px',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#007bff',
    cursor: 'pointer',
  },
  buttonGroup: { display: 'flex', justifyContent: 'space-between', marginTop: '20px' },
  button: { 
    padding: '10px 20px', 
    fontSize: '16px', 
    backgroundColor: 'var(--green-eucalyptus)', 
    color: 'black', 
    border: '5px black', 
    borderRadius: '5px', 
    cursor: 'pointer'
  },
  logoutButton: { 
    padding: '10px 20px', 
    fontSize: '16px', 
    color: 'red',
    cursor: 'pointer',
    border: 'none', 
 },
  error: { color: 'red', marginBottom: '10px' },
  success: { color: 'green', marginBottom: '10px' },
};

export default UserForm;